export const templateTypes = {
  LABEL: 'label',
  PRINT: 'print',
};

export const directions = {
  right: 'right',
  left: 'left',
  top: 'top',
  bottom: 'bottom',
};
